// 导入 axios 请求
import axios from 'axios'
import $router from '@/router/index.js'
import { Loading } from 'element-ui'
import $msg from '@/utils/message.js'
import $store from '@/store/index.js'

// 导入 进度条 Nprogress 包对应的 js 和 css
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

// 配置请求根路径
// axios.defaults.baseURL = 'http://127.0.0.1:9000'


axios.defaults.baseURL = 'https://gnjyht.gagasaas.com'

var load = null
// 配置请求拦截
axios.interceptors.request.use(req => {
	let whiteList = ['/common/captcha/getCaptcha','/admin/fwUser/login',
	'/admin/fwModel/modelList','/admin/fwEventAttr/list','/admin/fwModelEvent/getApiFilePower']
	if(!whiteList.includes(req.url)){
		let token = localStorage.getItem("token")
		if(token) req.headers.token = token
		else {
			$store.commit('clearLoginInfo')
			$router.replace('/login')
			return $msg.error('请先登录')
		}
	}
	// 加载动画
	load = Loading.service({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	Nprogress.start()
	return req
})

// 配置响应拦截器
axios.interceptors.response.use(res => {
	load.close()
	Nprogress.done()
	if(res.data.code != 200){
		if(res.data.code == 420 || res.data.code == 421 ){
			$store.commit('clearLoginInfo')
			$router.replace('/login')
		}
		$msg.error(res.data.message)
		return Promise.reject(res.data.message)
	}
	return res.data.data
}, (error) => {
	load.close()
	Nprogress.done()
	try{
		let errorCode = error.response.status
		if(errorCode == 401 || errorCode == 403){
			$store.commit('clearLoginInfo')
			$router.replace('/login')
		}else{
			$msg.error('服务器繁忙，请稍后重试')
		}
		return Promise.reject(error)
	}catch(e){
		$msg.error('请求异常，请稍后重试')
	}
})


export default axios